import React from 'react';
import './CommercialCTA.css';

const CommercialCTA = () => {
  return (
    <section className="commercial-cta-section">
      <div className="commercial-cta-container">
        <h2 className="commercial-cta-title">
          Prêt à transformer votre approche commerciale ?
        </h2>
        
        <p className="commercial-cta-description">
          Rejoignez les entreprises qui ont déjà boosté leur ROI grâce à notre méthode éprouvée.
        </p>
        
        <div className="commercial-cta-buttons">
          <button className="commercial-cta-button primary">Demander une démo</button>
          <a href="https://www.videoask.com/fd8vz299c" target="_blank" rel="noopener noreferrer">
            <button className="commercial-cta-button secondary">Tester mon éligibilité</button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default CommercialCTA; 